<template>
  <div id="sig-container" class="full form-horizontal">
    <div class="loader" v-if="loading">
      <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
    </div>

    <div class="widget">
      <div
        class="
          widget-content widget-content-mini
          themed-background-dark-default
          text-light
        "
      >
        <span class="float-right text-muted">
          <button
            type="button"
            @click="$router.go(-1)"
            class="btn btn-xs btn-primary"
          >
            Volver
          </button>
        </span>
        Alturas de mora
      </div>
      <div
        class="widget-content border-bottom themed-background-muted text-center"
      ></div>
    </div>
    <h3 style="text-align: center"><b>Lista de alturas</b></h3>
    <div class="row d-flex justify-content-center">
      <div class="col-md-6">
        <div class="loader" v-if="loading">
          <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
        </div>
        <table-component :data="alturas" @click-event="clickEvent">
          <table-column
            slot="label"
            :label="'Rango Inicial'"
            v-bind:value="'rango_inicial'"
            :customClass="'text-left'"
          >
            ></table-column
          >
          <table-column
            slot="label"
            :label="'Rango Final'"
            v-bind:value="'rango_final'"
            :customClass="'text-left'"
          ></table-column>
          <table-column
            slot="label"
            :label="'Porcentaje'"
            v-bind:value="'porcentaje'"
            :customClass="'text-left'"
          ></table-column>
          <table-column slot="label" :label="'Acciones'" :icon="'fa'">
            <template
              slot="icon"
              :icon="'fa fa-trash'"
              :class="'btn btn-sm btn-primary'"
              :slug="'eliminar-altura'"
              :tooltip="'Eliminar altura de mora'"
            ></template>
            <!--template slot="icon" :icon="'fa fa-dollar'" :class="'btn btn-sm btn-primary'"></template>
                <template slot="icon" :icon="'fa fa-file-o'" :class="'btn btn-sm btn-primary dropdown-toggle'"></template-->
          </table-column>
        </table-component>
      </div>
      <div class="col-md-6">
        <div class="widget">
          <div
            class="
              widget-content
              border-bottom
              themed-background-muted
              text-center
            "
          >
            <bar-chart :grafica="'altura_mora'" />
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="w-100">
        <div class="containter border">
          <br />
          <h3 style="text-align: center"><b>Almacenar una nueva altura</b></h3>
          <br />
          <div class="form-group">
            <div class="form-inline justify-content-center">
              <label class="control-label col-lg-1" v-text="'Entre'"></label>

              <input
                type="text"
                class="form-control mb-2 mr-sm-2"
                placeholder="Rango inicial"
                v-model="params.rango_inicial"
                required
              />
              <label class="control-label col-lg-1" v-text="'Y'"></label>

              <input
                type="text"
                class="form-control mb-2 mr-sm-2"
                placeholder="Rango final"
                v-model="params.rango_final"
                required
              />
              <label
                class="control-label col-lg-1"
                v-text="'Descuento de'"
              ></label>

              <input
                type="text"
                class="form-control mb-2 mr-sm-2"
                placeholder="Porcentaje"
                v-model="params.porcentaje"
                required
              />

              <button class="btn btn-primary" @click="storeAltura()">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
    <div>
      <div class="w-100">
        <div class="containter border">
          <br />
          <h3 style="text-align: center">
            <b>Almacenar obligaciones para descuento de capital</b>
          </h3>

          <div class="loader" v-if="loading">
            <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
          </div>

          <div class="col-md-8">
            <p>
              <small style="font-size: 14px">
                Por medio de este modulo se podra cargar las obligaciones
                habiles para descuento de capital..
              </small>
            </p>

            <label class="btn btn-primary">
              <i class="fa fa-file-excel-o"></i>
              <input
                v-on:change="cargarDatos()"
                id="archivo"
                ref="archivo"
                name="archivo"
                type="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
                style="display: none"
              />
              Seleccionar archivo
            </label>
            &nbsp;
            <a :href="'../files/formato-cargue-condonacion.csv'" download>
              <label class="btn btn-success">
                <i class="fa fa-file-excel-o"></i>
                Descargar archivo
              </label>
            </a>

            <p style="padding-top: 15px; padding-bottom: 15px">
              <small style="font-size: 14px">
                Si tienes el formato listo con las obligaciones correspondientes
                podrás montarlo por medio del boton "Seleccionar archivo". En
                caso contrario, podras descargar el formato base para montar
                este cargue por medio de "Descargar archivo".
              </small>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  name: "AlturaMora",
  data: () => {
    return {
      params: {
        rango_inicial: null,
        rango_final: null,
        porcentaje: null,
      },
    };
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
    BarChart: () => import("@/components/chart/BarChartAlturaMora"),
  },
  computed: {
    ...mapGetters({ loading: "loading", alturas: "alturaMora/alturas" }),
  },
  methods: {
    getAlturas() {
      this.$store.dispatch("alturaMora/refresh_alturas", []);
      this.$store
        .dispatch("index", {
          endpoint: "altura_mora",
          params: { paginar: "false" },
        })
        .then((response) => {
          if (response.datos.length > 0) {
            this.$store.dispatch("alturaMora/refresh_alturas", response.datos);
          } else {
            /*this.$notify({
              title: "Advertencia!",
              type: "warning",
              content: "No se encontraron alturas de mora",
            });*/
          }
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta",
          });
        });
    },
    storeAltura() {
      this.$store
        .dispatch("store", {
          endpoint: "altura_mora",
          params: this.params,
        })
        .then((response) => {
          this.$notify({
            title: "Información almacenada!",
            type: "success",
            content: "Altura guardada correctamente",
          });
          this.limpiarFormulario();
          this.getAlturas();
        })
        .catch((err) => {
          if (err.status == 422) {
            let datos = Object.values(err.data.errors);
            datos.forEach((element) => {
              this.$notify({
                title: "Advertencia!",
                type: "warning",
                content: element.join(", "),
              });
            });
          } else {
            this.$notify({
              title: "Advertencia!",
              type: "danger",
              content: "Se ha presentado un error realizando su consulta",
            });
          }
          this.limpiarFormulario();
        });
    },
    cargarDatos() {
      let file = this.$refs.archivo.files[0];
      if (file) {
        let file_name = file.name.replace(".csv", "");
        if (file_name.length > 28) {
          file_name = "response";
        }
        let formData = new FormData();
        formData.append("datos", file);

        this.$store
          .dispatch("store", {
            endpoint: "altura_mora/importar",
            params: formData,
          })
          .then((response) => {
            if (response.length > 0) {
              let log = XLSX.utils.json_to_sheet(response);

              var workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, log, "Log_" + file_name);
              var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
              var wbout = XLSX.write(workbook, wopts);
              saveAs(
                new Blob([wbout], { type: "application/octet-stream" }),
                "Log_" + file_name + ".xlsx"
              );
            } else {
              this.$notify({
                title: "Error!",
                content: "Se ha generado un error exportando el log.",
                type: "warning",
              });
            }

            this.$notify({
              title: "Archivo procesado",
              content: "Se han importado con exito las obligaciones.",
              type: "success",
            });
          })
          .catch((err) => {
            this.$notify({
              title: "Error!",
              content: "Se ha generado un error importando los datos." + err,
              type: "danger",
            });
          });
      }
    },
    limpiarFormulario() {
      this.params.rango_inicial = null;
      this.params.rango_final = null;
      this.params.porcentaje = null;
    },
    clickEvent(data, slug) {
      switch (slug) {
        case "eliminar-altura":
          if (confirm("¿Está seguro que desea cancelar ésta altura de mora?")) {
            this.eliminarAltura(data);
          }
          break;
      }
    },
    eliminarAltura(altura) {
      this.$store
        .dispatch("remove", { endpoint: "altura_mora/" + altura.id })
        .then((response) => {
          this.$notify({
            title: "Invalidado!",
            type: "success",
            content: "Se eliminó la altura satisfactoriamente",
          });
          this.getAlturas();
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content: "Ha ocurrido un problema eliminando la altura",
          });
        });
    },
  },
  mounted() {
    //
    this.getAlturas();
  },
};
</script>
